import {css} from "styled-components";
import {getFontSize, getFontWeight, getLetterSpacing, getLineHeight} from "@/pipes/theme.pipe";

const sizeOptions = {
    xs: css`
        font-size: ${getFontSize('text', 'xs')};
        font-weight: ${getFontWeight('400')};
        line-height: ${getLineHeight('text', 'xs')};
        letter-spacing: ${getLetterSpacing('text', 'xs')};
    `,
    sm: css`
        font-size: clamp(${getFontSize('text', 'xs')}, 4vw, ${getFontSize('text', 'sm')});
        font-weight: ${getFontWeight('400')};
        line-height: ${getLineHeight('text', 'xs')};
        letter-spacing: ${getLetterSpacing('xs')};
    `,
    md: css`
        font-size: clamp(${getFontSize('text', 'xs')}, 4vw, ${getFontSize('text', 'md')});
        font-weight: ${getFontWeight('400')};
        line-height: clamp(${getLineHeight('text', 'xs')}, 4vw, ${getLineHeight('text', 'sm')});
        letter-spacing: clamp(${getLetterSpacing('xs')}, 4vw, ${getLetterSpacing('sm')});
    `,
    lg: css`
        font-size: clamp(${getFontSize('text', 'xs')}, 2vw, ${getFontSize('text', 'lg')});
        font-weight: ${getFontWeight('400')};
        line-height: clamp(${getLineHeight('text', 'xs')}, 3vw, ${getLineHeight('text', 'sm')});
        letter-spacing: clamp(${getLetterSpacing('sm')}, 3vw, ${getLetterSpacing('md')});
    `,
    xl: css`
        font-size: clamp(${getFontSize('text', 'xs')}, 2vw, ${getFontSize('text', 'xl')});
        font-weight: ${getFontWeight('600')};
        line-height: clamp(${getLineHeight('text', 'xs')}, 4vw, ${getLineHeight('text', 'sm')});
        letter-spacing: clamp(${getLetterSpacing('sm')}, 4vw, ${getLetterSpacing('md')});
    `,
};

export const getSizeStyles = ({size}) => sizeOptions[size] ?? sizeOptions['md']